import { render, staticRenderFns } from "./MinimalPagination.vue?vue&type=template&id=5c7d8d9e&"
import script from "./MinimalPagination.vue?vue&type=script&lang=js&"
export * from "./MinimalPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports